import {
  apiDELETE,
  apiGET,
  apiPOST
} from "./chunk-NB6PR3JZ.mjs";

// src/adapters/payments.ts
var getDepositPaymentProviders = async () => {
  return await apiGET("/payment-providers/deposit");
};
var prevalidateWithdrawal = async () => {
  return await apiGET("/payments/withdrawal/prevalidate");
};
var cancelWithdrawals = async (ids) => {
  return await apiDELETE("/payments/pending-withdrawals", {
    data: { transaction_ids: ids }
  });
};
var getDepositCapabilites = async () => {
  return await apiGET("/capabilities/deposit");
};
var getPaymentDepositLobby = async () => {
  return await apiGET("/lobbies/deposit");
};
var getPaymentWithdrawalLobby = async () => {
  return await apiGET("/lobbies/withdrawal");
};
var getLivenessStatus = async (onboardingId) => {
  return await apiGET(`/liveness/${onboardingId}`);
};
var requestBankAccountWithdraw = async (body) => {
  return await apiPOST("/payments/v2/withdrawal/pix", body);
};
var requestDepositV2 = async ({
  endpoint,
  body
}) => {
  return await apiPOST(endpoint, body);
};
var requestDepositStatusV2 = async ({
  endpoint,
  transactionReference
}) => {
  const params = { reference: transactionReference };
  return await apiGET(endpoint, { params });
};
var requestLivenessPixPing = async () => {
  return await apiPOST("/ping-pay/liveness");
};
var createPixPingBankAccount = async (body) => {
  return await apiPOST("/ping-pay", body);
};
var getPlayerDepositOptions = async () => {
  return await apiGET("/payments/player/deposit-options/");
};
var getDirectaBanks = async () => {
  return await apiGET("/directa/banks");
};
var requestGigadatWithdrawal = async (body) => {
  return await apiPOST("/payments/withdrawal/gigadat", body);
};
var requestPay4FunWithdrawal = async (body) => {
  return await apiPOST("/payments/withdrawal/pay4fun", body);
};
var requestInovapayGatewayWithdrawal = async (body) => {
  return await apiPOST("/payments/withdrawal/inovapay-gateway", body);
};
var requestInovapayWithdrawal = async (body) => {
  return await apiPOST("/payments/withdrawal/inovapay", body);
};
var requestDirectaWithdrawal = async (body) => {
  return await apiPOST("/payments/withdrawal/directa", body);
};
var requestPay4FunGoPixWithdrawal = async (body) => {
  return await apiPOST("/payments/withdrawal/pay4fun-go-pix", body);
};
var requestPaylivreWithdrawal = async (body) => {
  return await apiPOST("/payments/withdrawal/paylivre", body);
};
var requestPagseguroWithdrawal = async (body) => {
  return await apiPOST("/payments/withdrawal/pagseguro", body);
};
var getPaymentIQData = async (type) => {
  return await apiGET(`/payments/iq-data/${type}`);
};
var createBankAccount = async (body) => {
  return await apiPOST("/bank-accounts", body);
};

export {
  getDepositPaymentProviders,
  prevalidateWithdrawal,
  cancelWithdrawals,
  getDepositCapabilites,
  getPaymentDepositLobby,
  getPaymentWithdrawalLobby,
  getLivenessStatus,
  requestBankAccountWithdraw,
  requestDepositV2,
  requestDepositStatusV2,
  requestLivenessPixPing,
  createPixPingBankAccount,
  getPlayerDepositOptions,
  getDirectaBanks,
  requestGigadatWithdrawal,
  requestPay4FunWithdrawal,
  requestInovapayGatewayWithdrawal,
  requestInovapayWithdrawal,
  requestDirectaWithdrawal,
  requestPay4FunGoPixWithdrawal,
  requestPaylivreWithdrawal,
  requestPagseguroWithdrawal,
  getPaymentIQData,
  createBankAccount
};
